const selectUserActionTypes = state => state.data.userActionTypes

const UserActionTypeDataStoreSelectors = {
  userActionTypes: selectUserActionTypes
}

export default UserActionTypeDataStoreSelectors
